import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    timeout: Boolean,
    title: String,
    message: String,
    openOnSubmit: Boolean,
  };

  connect() {
    document.addEventListener("turbo:frame-load", () => {
      this.closeModal("#modal-loading");
    });

    document.addEventListener("turbo:load", () => {
      this.closeModal("#modal-loading");
    });

    document.addEventListener("turbo:before-stream-render", () => {
      this.closeModal("#modal-loading");
    });

    let buttons = this.element.querySelectorAll("button");
    if (buttons.length === 0) {
      buttons = this.element.querySelectorAll("a");
    }
    buttons.forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    if (this.openOnSubmitValue) {
      const form = this.element.querySelector("form");
      if (form) {
        form.addEventListener("submit", this.openOnFormSubmit.bind(this));
      }
    }

    window.addEventListener("pageshow", this.onPageshow.bind(this));
  }

  onButtonClick(event) {
    const form = this.targetForm(event.currentTarget);
    const shouldShowModal = !form || (form && form.checkValidity());

    if (shouldShowModal) {
      this.showLoadingModal();
    }
  }

  targetForm(target) {
    if (!target) return null;

    if (target.form) {
      return target.form;
    }

    const formId = target.getAttribute?.("form");
    if (formId) {
      return document.getElementById(formId);
    }

    return target.closest("form");
  }

  openOnFormSubmit(event) {
    // Use setTimeout to defer until after all synchronous submit handlers have run.
    setTimeout(() => {
      if (!event.defaultPrevented) {
        this.showLoadingModal();
      }
    }, 0);
  }

  showLoadingModal() {
    setTimeout(() => this.showModal("#modal-loading"), this.timeoutValue ? 1000 : 0);
  }

  onPageshow(event) {
    if (event.persisted) {
      this.closeModal("#modal-loading");
    }
  }

  showModal(modalSelector) {
    const modal = document.querySelector(modalSelector);

    if (!modal) return;

    if (this.titleValue) {
      const titleElement = modal.querySelector("#loading-modal-title");
      if (titleElement) {
        titleElement.textContent = this.titleValue;
      }
    }

    if (this.messageValue) {
      const messageElement = modal.querySelector("#loading-modal-message");
      if (messageElement) {
        messageElement.textContent = this.messageValue;
      }
    }

    window.HSOverlay.open(modalSelector);
    this.modalOpen = true;
  }

  closeModal(modalSelector) {
    if (this.modalOpen) {
      window.HSOverlay.close(modalSelector);
      this.modalOpen = false;
    }
  }
}
